import { useState } from 'react'

import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  Input,
  FormControl,
  FormLabel,
  Stack,
  ModalCloseButton,
} from '@chakra-ui/react'
import { ModalCancelButton } from 'src/lib/chakra-theme/components'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { GetPatientReturn, useEnablePatient } from '../../api'

type Props = {
  patient: GetPatientReturn
  isOpen: boolean
  mutatePatient: () => void
  onClose: () => void
  onCloseEditPatientModal: () => void
}

export const EnablePatientModal: React.FC<Props> = ({
  patient,
  mutatePatient,
  isOpen,
  onClose,
  onCloseEditPatientModal,
}) => {
  const [reason, setReason] = useState('')

  const handleClose = () => {
    setReason('')
    onClose()
  }

  const toast = useMirohaToast()

  const { request: enablePatient } = useEnablePatient({
    onSuccess: () => {
      toast({
        status: 'success',
        title: '登録患者を有効化しました',
      })
      mutatePatient()
      handleClose()
      onCloseEditPatientModal()
    },
    onError: error => {
      toast({ status: 'error', title: error.message })
    },
  })

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    if (!reason) return

    e.preventDefault()
    await enablePatient({ patientUid: patient.uid, reason })
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <form onSubmit={handleSubmit}>
          <ModalHeader>登録患者を有効化</ModalHeader>
          <ModalBody>
            <Stack spacing="8">
              <Text fontSize="md">
                症例番号: <strong>{patient.diseaseUid}</strong>
                さんを有効化します。
              </Text>
              <FormControl>
                <FormLabel>有効化理由</FormLabel>
                <Input
                  placeholder="有効化理由を入力してください"
                  value={reason}
                  onChange={e => setReason(e.target.value)}
                />
              </FormControl>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <ModalCancelButton />
            <Button colorScheme="blue" type="submit" isDisabled={!reason}>
              有効化する
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  )
}
